import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

const Rsucc = (props) => {
  const { apiUrl, history } = props;

  let orderCode = new URL(window.location.href).searchParams.get('orderId');
  let paymentKey = new URL(window.location.href).searchParams.get('paymentKey');
  let amount = new URL(window.location.href).searchParams.get('amount');

  console.log(orderCode, paymentKey, amount);

  const _callApi = async (req, res) => {
    const result = await axios.post(apiUrl + '/collaboReservePay', {
      orderCode,
      paymentKey,
      amount,
    });

    const intReturn = result.data[0].intReturn;
    const data = result.data[0].data;
    console.log(intReturn);

    if (intReturn === 0) {
      toast.success('카페예약이 성공적으로 완료되었습니다.');
      history.push(`/cr/${orderCode}`);
    } else if (intReturn === -1) {
      toast.error('결제정보가 누락되었습니다.');
      history.push(
        `/rfail?orderId=${orderCode}&code=${'-1'}&message=${'결제정보가 누락.'}`
      );
    } else if (intReturn === -5) {
      toast.error('예약시간의 인원이 초과되었습니다.');
      history.push(
        `/rfail?orderId=${orderCode}&code=${'-1'}&message=${'인원초과.'}`
      );
    } else if (intReturn === -5) {
      toast.error('예약 인원이 초과되었습니다.');
      history.push(
        `/rfail?orderId=${orderCode}&code=${'-1'}&message=${'한정메뉴 수량 초과.'}`
      );
    } else if (intReturn === -6) {
      toast.error('한정 메뉴가 매진되었습니다.');
      history.push(
        `/rfail?orderId=${orderCode}&code=${'-1'}&message=${'한정메뉴 수량 초과.'}`
      );
    } else if (intReturn === -3) {
      toast.error('결제금액이 일치하지 않습니다.');
      history.push(
        `/rfail?orderId=${orderCode}&code=${'-1'}&message=${'결제금액 불일치.'}`
      );
    } else if (intReturn === -2) {
      toast.error('오류로 인해 결제가 취소되었습니다.');
      history.push(
        `/rfail?orderId=${orderCode}&code=${'-1'}&message=${'롤백.'}`
      );
    } else {
      alert('오류발생.');
    }
  };

  useEffect(() => {
    _callApi();
  }, []);

  return <div></div>;
};

export default shopContext(withRouter(Rsucc));
